import { useMemo } from "react";
import { useSvgViewBoxZoom } from "../../hooks/useSvgViewBoxZoom";
import { useChannelSplit } from "./ChannelSplitContext";

export function ChannelSplitViewer() {
    const {
        svg,
        exportSvgString,
        viewBoxAttr,
        canExport,
        handleDownload,
    } = useChannelSplit();

    const displayContent = useMemo(() => {
        if (!exportSvgString) return null;
        // Render inside a controlled svg for consistent zoom sizing.
        return exportSvgString.replace(/<\/?svg[^>]*>/gi, "").trim();
    }, [exportSvgString]);

    const base = useMemo(() => {
        const [x, y, w, h] = viewBoxAttr.split(" ").map(Number);
        return { x, y, w, h };
    }, [viewBoxAttr]);

    const {
        svgRef,
        viewBoxAttr: viewBox,
        panHandlers,
        zoomPercent,
        zoomIn,
        zoomOut,
        resetView,
    } = useSvgViewBoxZoom({ base });

    return (
        <div className="panel-viewer channel-split-viewer">
            <div className="path-tool-preview">
                <div className="svg-zoom-controls">
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomOut}
                        title="Zoom out"
                    >
                        −
                    </button>
                    <span className="zoom-level">{zoomPercent}%</span>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomIn}
                        title="Zoom in"
                    >
                        +
                    </button>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={resetView}
                        title="Reset zoom"
                    >
                        ⌂
                    </button>
                </div>

                <div className="svg-scroll-wrapper">
                    <div className="svg-container channel-split-svg-container svg-container--fill">
                        {displayContent ? (
                            <svg
                                ref={svgRef}
                                viewBox={viewBox}
                                xmlns="http://www.w3.org/2000/svg"
                                overflow="visible"
                                className="path-tool-svg channel-split-svg-host"
                                style={{ touchAction: "none" }}
                                {...panHandlers}
                                dangerouslySetInnerHTML={{
                                    __html: displayContent,
                                }}
                            />
                        ) : (
                            <div className="svg-placeholder">
                                <p>Import an SVG to split channels.</p>
                                <p className="svg-placeholder-hint">
                                    Vector artwork is duplicated per channel
                                    with color-matrix filters and optional
                                    filter/path displacement roughen.
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                <div className="path-tool-footer">
                    <p className="path-tool-meta">
                        {svg
                            ? `${svg.name} — viewBox: ${viewBoxAttr}`
                            : "Waiting for SVG file."}
                    </p>
                    <button
                        type="button"
                        className="generic-button"
                        disabled={!canExport}
                        onClick={handleDownload}
                    >
                        Download SVG
                    </button>
                </div>
            </div>
        </div>
    );
}
